"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.list = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const config_1 = require("../config/config");
const constants_1 = require("../constants");
const errorMessages_1 = require("../errorMessages");
const types_1 = require("../types");
/**
 * Lists a token on mintbase market contract
 * @param listArguments {@link ListArgs}
 * @returns contract call to be passed to @mintbase-js/sdk execute method
 */
const list = (args) => {
    const { contractAddress = config_1.mbjs.keys.contractAddress, tokenId, marketAddress = config_1.mbjs.keys.marketAddress, price } = args;
    if (contractAddress == null) {
        throw new Error(errorMessages_1.ERROR_MESSAGES.CONTRACT_ADDRESS);
    }
    const msg = { price: price };
    if (args.ft) {
        const ftContractId = config_1.mbjs.keys.ftAddresses[args.ft];
        msg.ft_contract = ftContractId;
    }
    return {
        contractAddress: contractAddress || config_1.mbjs.keys.contractAddress,
        args: {
            token_id: tokenId,
            account_id: marketAddress,
            msg: JSON.stringify(msg),
        },
        methodName: types_1.MARKET_METHOD_NAMES.LIST,
        deposit: constants_1.LISTING_DEPOSIT,
        gas: constants_1.GAS,
    };
};
exports.list = list;
//# sourceMappingURL=list.js.map